import React from 'react';
import { Wrench, Cylinder, ShieldCheck, Zap } from 'lucide-react';
export function Services() {
  const iconClass = 'w-8 h-8 text-orange';
  const iconStroke = 2;
  const services = [{
    title: 'Powerstroke Specialties',
    description: 'Professional diagnostics, head studs (ARP Studs), oil cooler kits, and EGR solutions for all Ford Diesel generations.',
    icon: <Wrench className={iconClass} strokeWidth={iconStroke} data-id="element-220" data-mp="13vl6k913oqzd" />
  }, {
    title: 'Engine Reconditioning',
    description: 'Full engine reseal service, turbocharger maintenance, and high-performance upgrades.',
    icon: <Cylinder className={iconClass} strokeWidth={iconStroke} data-id="element-221" data-mp="u6uwe9vwpwpa" />
  }, {
    title: 'General Auto Care',
    description: 'Professional brakes, suspension tuning, transmission service, and preventive maintenance for all pickups and SUVs.',
    icon: <ShieldCheck className={iconClass} strokeWidth={iconStroke} data-id="element-222" data-mp="g6k5j6ulki44" />
  }, {
    title: 'Electrical Diagnostics',
    description: 'Solving complex wiring issues, computer programming, and battery/alternator testing using factory-grade equipment.',
    icon: <Zap className={iconClass} strokeWidth={iconStroke} data-id="element-223" data-mp="3b5al2lcr086h" />
  }];
  return <section id="services" className="py-24 bg-slate-50" data-id="element-224" data-mp="2xdmd8u9j85vb">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225" data-mp="32a30lm8wqg7c">
        <div className="text-center mb-16" data-id="element-226" data-mp="328i4hs6y2p7d">
          <h2 className="text-4xl md:text-5xl font-display text-dark mb-4" data-id="element-227" data-mp="3q1i7lsbmplox">
            Specialized Engine Care
          </h2>
          <div className="w-24 h-1 bg-orange mx-auto" data-id="element-228" data-mp="3u1in7gags2xk"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-229" data-mp="3g17u06lomc98">
          {services.map((service, index) => <div key={index} className="bg-white p-8 rounded-xl border border-slate-200 border-l-[6px] border-l-orange shadow-sm hover:shadow-md transition-all hover:-translate-y-1 group" data-id="element-230" data-mp="3l02oi5t0hp96" data-mpi={index}>
              <div className="flex items-start" data-id="element-231" data-mp="29juexkf5xdo0">
                <div className="flex-shrink-0 bg-slate-50 p-3 rounded-lg group-hover:bg-orange/10 transition-colors" data-id="element-232" data-mp="1pj17pztm1usm">
                  {service.icon}
                </div>
                <div className="ml-6" data-id="element-233" data-mp="1grivfzzsbz4t">
                  <h3 className="text-xl font-bold text-dark mb-3" data-id="element-234" data-mp="1gqhfbh3wwmg8">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed" data-id="element-235" data-mp="1bqlbbhv7sv0o">
                    {service.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}